var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-menu-item"},[_c('img',{attrs:{"src":_vm.getImgUrl(_vm.item.pic)}}),_c('router-link',{staticClass:"block-menu-item-text",attrs:{"to":_vm.item.url}},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }